import { render } from "./FormBottom.vue?vue&type=template&id=4cd946f1"
import script from "./FormBottom.vue?vue&type=script&lang=js"
export * from "./FormBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__